import {useQuery} from '@tanstack/react-query';
import {GetB2BBeneficiaryStatusParams} from 'domain/usecases/others/selection-flow/b2b/get-b2b-beneficiary-status';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {getB2BBeneficiaryStatus} from 'presentation/services/getB2BBeneficiaryStatus';

export const useGetB2BBeneficiaryStatusQuery = (params: GetB2BBeneficiaryStatusParams) =>
	useQuery({
		queryKey: [QUERY_KEYS.B2B_BENEFICIARY_STATUS, params],
		queryFn: () => getB2BBeneficiaryStatus(params),
	});
